import { ACTIONS } from './types';
import { api } from '../../../configs/api';
import { InputStateToken } from '@voltmoney/schema';
import { AssetRepositoryMap, AssetRepositoryType, ConfigTokens, getAppHeader, } from '../../../configs/config';
import { nextStepCredStepper, nextStepId, ShowNewRTAFetchError } from '../../../configs/utils';
import _ from 'lodash';
import SharedPropsService from '../../../SharedPropsService';
import { AnalyticsEventTracker } from '../../../configs/constants';
import { ROUTE } from '../../../routes';
import { Platform } from "react-native";
import AsyncStorage from "@react-native-async-storage/async-storage";
let resendCount = 0;
let isError = false;
export const fetchMyPortfolio = async (action, _datastore, { instrumentTrack, network, navigate, setDatastore, navigateWithClear, goBack }) => {
    await instrumentTrack("FETCH_RESEND_OTP_CLICKED");
    const user = await SharedPropsService.getUser();
    const panNumber = user.linkedBorrowerAccounts[0].accountHolderPAN;
    const phoneNumber = user.linkedBorrowerAccounts[0].accountHolderPhoneNumber;
    const emailId = user.linkedBorrowerAccounts[0].accountHolderEmail;
    let applicationId = '';
    if (await AsyncStorage.getItem("application_id") !== null) {
        applicationId = await AsyncStorage.getItem("application_id");
    }
    else {
        applicationId = user.linkedApplications[0].applicationId;
    }
    instrumentTrack("GET_MF_PORTFOLIO_OTP_RESEND", {
        "getFolioFrom": action.payload.assetRepository,
        "attempt_count": resendCount
    });
    resendCount++;
    const showNewRTAFetchError = await ShowNewRTAFetchError();
    let response;
    if (showNewRTAFetchError) {
        response = await network.post(api.mfFetchInitV3, {
            applicationId: applicationId,
            emailId: emailId,
            panNumber: panNumber,
            phoneNumber: phoneNumber,
            assetRepository: action.payload.assetRepository,
        }, {
            headers: await getAppHeader(),
        });
    }
    else {
        response = await network.post(api.fetchInitV2, {
            applicationId: applicationId,
            emailId: emailId,
            panNumber: panNumber,
            phoneNumber: phoneNumber,
            assetRepository: action.payload.assetRepository,
        }, {
            headers: await getAppHeader(),
        });
    }
    if (_.get(response, 'data.status') === 'SUCCESS') {
        await setDatastore(ROUTE.PLEDGE_VERIFY, "otpModalScreen", {
            state: InputStateToken.DEFAULT,
        });
    }
};
export const authCAS = async (action, _datastore, { navigate, setDatastore, network, analytics, showPopup, hidePopup, goBack, navigateWithClear, ...props }) => {
    const standardUtilities = {
        navigate,
        setDatastore,
        network,
        analytics,
        showPopup,
        hidePopup,
        goBack,
        navigateWithClear,
        ...props
    };
    const isRetryAllowed = action?.payload?.isRetryAllowed;
    let assetRepositoryType = await SharedPropsService.getAssetRepositoryType();
    if (action.payload.value.length !==
        AssetRepositoryMap.get(assetRepositoryType).OTP_LENGTH) {
        return;
    }
    await setDatastore(action.routeId, "otpModalScreen", {
        state: InputStateToken.LOADING,
    });
    let applicationId = "";
    if (await AsyncStorage.getItem("application_id") !== null) {
        applicationId = await AsyncStorage.getItem("application_id");
    }
    else {
        applicationId = (await SharedPropsService.getUser())
            .linkedApplications[0].applicationId;
    }
    let response;
    const showNewRTAFetchError = await ShowNewRTAFetchError();
    if (showNewRTAFetchError) {
        // --------- NEW RTA FETCH ERROR ----------//
        response = await network.post(api.mfAuthCasV2, {
            applicationId: applicationId,
            otp: action.payload.value,
            assetRepository: assetRepositoryType,
        }, { headers: await getAppHeader() }, async () => { }, {
            disableDefault: true
        });
        // -------------------------------- //
    }
    else {
        // --------- OLD RTA FETCH ----------//
        response = await network.post(api.authCAS, {
            applicationId: applicationId,
            otp: action.payload.value,
            assetRepository: assetRepositoryType,
        }, { headers: await getAppHeader() }, async () => { }, {
            disableDefault: true
        });
        // -------------------------------- //
    }
    if (response?.status === 200) {
        // --------- NEW RTA FETCH ERROR ----------//
        if (showNewRTAFetchError &&
            response?.data?.status?.toUpperCase() === 'FAILURE') {
            if (Platform.OS === 'web') {
                //@ts-ignore
                window?.ReactNativeWebView?.postMessage("NO_PORTFOLIO_FOUND");
            }
            standardUtilities.instrumentTrack('GET_MF_PORTFOLIO_OTP_USER', {
                result: false,
                rta: assetRepositoryType,
                error_type: response?.data?.stepResponseObject?.error?.header
            });
            const fetchPortfolioPayload = {
                applicationId: applicationId,
                assetRepository: assetRepositoryType,
                emailId: action.payload?.emailId,
                panNumber: action.payload?.panNumber,
                phoneNumber: action.payload?.phoneNumber,
            };
            //close the auth case modal
            // await goBack();
            // setTimeout(async()=> {
            //     await CamsFetchErrorHandle(
            //         standardUtilities,
            //         {
            //             response,
            //             fetchPortfolioPayload,
            //             isRetryAllowed: isRetryAllowed
            //         }
            //     );
            // }, 60);
            await SharedPropsService.setIsRTAError(true);
            await navigate(ROUTE.MF_FETCH_PORTFOLIO, {
                assetRepository: fetchPortfolioPayload?.assetRepository,
                isRTAError: true,
                CamsFetchErrorHandleData: {
                    response: response,
                    fetchPortfolioPayload: fetchPortfolioPayload,
                    isRetryAllowed: isRetryAllowed
                }
            });
            return;
            // -------------------------------- //
        }
        standardUtilities.instrumentTrack('GET_MF_PORTFOLIO_OTP_USER', {
            result: true,
            rta: assetRepositoryType,
            error_type: ''
        });
        await analytics("eligibility_success", { "event": "eligibility_success" });
        /*** check available credit limit ***/
        const availableCreditAmount = _.get(response, showNewRTAFetchError ?
            'data.stepResponseObject.success.availableCreditAmount'
            : 'data.stepResponseObject.availableCreditAmount', 0);
        /*** check max loan amount ***/
        const maxLoanAmount = _.get(response, showNewRTAFetchError ?
            'data.stepResponseObject.success.maxLoanAmount'
            : 'data.stepResponseObject.maxLoanAmount', 0);
        /** set max loan amount in config ***/
        await SharedPropsService.setConfig(ConfigTokens.MAX_AMOUNT_ALLOWED, maxLoanAmount);
        if (availableCreditAmount > 0) {
            analytics(AnalyticsEventTracker.borrower_mf_pull['Event Name'], {
                ...AnalyticsEventTracker.borrower_mf_pull,
            });
            if (showNewRTAFetchError) {
                // The structure for stepResponseObject was changed for the showNewRTAFetchError flow
                const stepResponseObject = response?.data?.stepResponseObject?.success;
                await SharedPropsService.setAuthCASResponse({
                    ...response.data,
                    stepResponseObject: stepResponseObject
                });
            }
            else {
                await SharedPropsService.setAuthCASResponse(response.data);
            }
        }
        else {
            analytics(AnalyticsEventTracker.borrower_mf_pull_failed['Event Name'], {
                ...AnalyticsEventTracker.borrower_mf_pull_failed,
            });
        }
        await setDatastore(action.routeId, "otpModalScreen", {
            state: InputStateToken.SUCCESS,
        });
        if (_.get(response, 'data.updatedApplicationObj.currentStepId', false)) {
            /**  enable animation again ***/
            const layoutType = await SharedPropsService.getConfig(ConfigTokens.IS_MF_FETCH_BACK_ALLOWED);
            /*** Don't run animation MF_FETCH is not full screen */
            if (!layoutType)
                await SharedPropsService.setPledgeFirstTime(true);
            const stepMap = response?.data?.updatedApplicationObj?.stepStatusMap;
            const isElevate = await SharedPropsService.getElevateFlow();
            let nextRoute;
            if (isElevate) {
                nextRoute = await nextStepCredStepper(response.data.updatedApplicationObj.currentStepId, stepMap);
            }
            else {
                nextRoute = await nextStepId(response.data.updatedApplicationObj.currentStepId);
            }
            nextRoute.params = { ...nextRoute.params, response };
            await hidePopup();
            const assetRepository = action?.payload?.assetRepository;
            if (assetRepository === AssetRepositoryType.MFCENTRAL) {
                await navigate(ROUTE.MFC_FETCH_EVALUTE_FUNDS);
            }
            else {
                await navigateWithClear(nextRoute.routeId, nextRoute.params);
            }
        }
    }
    else if (response?.response?.status === 500) {
        isError = true;
        if (Platform.OS === "ios") {
            await goBack();
        }
        await showPopup({
            type: 'FAILED',
            title: 'Sorry something went wrong  ',
            subTitle: `${response?.response?.data?.message}`,
            ctaLabel: 'Okay',
            primary: true,
            ctaAction: {
                routeId: ROUTE.OTP_AUTH_CAS,
                type: ACTIONS.GO_BACK,
                payload: {}
            }
        });
    }
    else {
        if (_.get(response, 'response.data.voltErrorCode', false) === "MF_OTP_INVALID") {
            await setDatastore(action.routeId, "otpModalScreen", {
                state: InputStateToken.ERROR,
                caption: { error: _.get(response, 'response.data.message') }
            });
        }
        if (_.get(response, 'response.data.voltErrorCode', false) === "MF_OTP_ATTEMPTS_EXHAUSTED" || _.get(response, 'response.data.voltErrorCode', false) === "ACCOUNT_BLOCKED_FROM_OTP") {
            await setDatastore(action.routeId, "otpModalScreen", {
                state: InputStateToken.DISABLED,
                caption: { error: _.get(response, 'response.data.message') }
            });
        }
        if (_.get(response, 'response.data.voltErrorCode', false) === "MF_PORTFOLIO_NOT_FOUND") {
            if (Platform.OS === "ios") {
                await goBack();
            }
            await showPopup({
                type: 'FAILED',
                title: 'Verification failed!',
                subTitle: `${response?.response?.data?.message}`,
                ctaLabel: 'Okay',
                primary: true,
                ctaAction: {
                    routeId: ROUTE.OTP_AUTH_CAS,
                    type: ACTIONS.GO_BACK,
                    payload: {}
                }
            });
            isError = true;
        }
        if (_.get(response, 'response.data.voltErrorCode', false) === "MF_NO_ACCOUNT_FOUND_MATCHING_DETAILS") {
            if (Platform.OS === "ios") {
                await goBack();
            }
            await showPopup({
                type: 'FAILED',
                title: 'Verification failed!',
                subTitle: `${response?.response?.data?.message}`,
                ctaLabel: 'Okay',
                primary: true,
                ctaAction: {
                    routeId: ROUTE.OTP_AUTH_CAS,
                    type: ACTIONS.GO_BACK,
                    payload: {}
                }
            });
            isError = true;
        }
    }
};
export const goBack = async (action, _datastore, { goBack }) => {
    await SharedPropsService.setIsFetchedErrorShowOnce(false);
    if (Platform.OS === "ios") {
        await goBack();
    }
    else {
        await goBack();
        if (isError) {
            await goBack();
            isError = false;
        }
    }
};
export const navToFetch = async (action, _datastore, { navigate }) => {
    navigate(ROUTE.MF_FETCH_PORTFOLIO);
};
